import { Box } from '@chakra-ui/react';

const Template = ({ children }: any) => {
  return (
    <Box
      textAlign="center"
      fontSize="xl"
      w={["92%", "88%", "85%"]}
      maxW={920}
      mx="auto"
    >
      <Box pt={12} pb={12}>
        {children}
      </Box>
    </Box>
  );
};

export default Template;
